<template>
  <div>
    <Card back>
      <template v-slot:header>
        <!-- Show -->
        <div v-if="showRow">
          <h4 class="d-inline">صدور لیست قیمت</h4>
          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(1)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
            </h4>
          </a>
        </div>

        <!-- Add -->
        <div v-if="addRow">
          <h4 class="d-inline">افزودن</h4>
          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(0)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-times text-danger"></i>
            </h4>
          </a>
        </div>

        <!-- Edit -->
        <div v-if="editRow">
          <h4 class="d-inline">ویرایش</h4>
          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(0)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-times text-danger"></i>
            </h4>
          </a>
        </div>

        <!-- Copy -->
        <div v-if="copyRow">
          <h4 class="d-inline">افزودن</h4>
          <a class="d-inline float-left mx-2 mt-1" href="javascript:;" @click="changeState(0)" data-title="ردیف جدید">
            <h4>
              <i class="fas fa-times text-danger"></i>
            </h4>
          </a>
        </div>

      </template>



      <template v-slot:content>
        <!-- Show -->
        <div v-if="showRow">
          <BnpGrid Selectable :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true"
            v-if="render">
            <template slot="action-slot" slot-scope="props">
              <div class="row justify-content-center">
                <!-- <div>
                                    <a href="javascript:;" class="badge text-center">
                                        <h6><span class="fas fa-eye font-weight-bold hover-info" @click="$router.push({
                                            name: 'PriceListDetails',
                                            params: {
                                                param: props.props
                                            }
                                        })"></span></h6>
                                    </a>
                                </div> -->

                <div>
                  <a href="javascript:;" class="badge text-center" @click="edit(props.props)">
                    <h6>
                      <span class="fas fa-eye font-weight-bold hover-info"></span>
                    </h6>
                  </a>
                </div>

                <div>
                  <a href="javascript:;" class="badge text-center" @click="print(props.props)">
                    <h6><span class="fad fa-print hover-info"></span></h6>
                  </a>
                </div>

                <div>
                  <a href="javascript:;" class="badge text-center" @click="copy(props.props)">
                    <h6><span class="fad fa-copy hover-danger"></span></h6>
                  </a>
                </div>

                <div>
                  <a href="javascript:;" class="badge text-center" @click="remove(props.props)">
                    <h6><span class="fa fa-times hover-danger"></span></h6>
                  </a>
                </div>



              </div>
            </template>
          </BnpGrid>
        </div>

        <!-- Add -->
        <div v-if="addRow" class="mt-3">
          <AddRow @addRowResult="addRowResult"> </AddRow>
        </div>

        <!-- Edit -->
        <div v-if="editRow">
          <EditRow @editRowResult="editRowResult" :item="itemForEdit">
          </EditRow>
        </div>

        <div v-if="copyRow">
          <CopyRow @addRowResult="addRowResult" :item="itemForCopy">
          </CopyRow>
        </div>


      </template>
    </Card>
  </div>
</template>

<script>
import Card from "@/components/Card/Card.vue";
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import AddRow from "./PriceListExportAdd.vue";
import EditRow from "./PriceListExportEdit.vue";
import CopyRow from "./PriceListExportCopy.vue";

export default {
  components: { Card, BnpGrid, SearchableCombo, AddRow, EditRow, CopyRow },

  data() {
    return {
      propsRows: [],
      propsColumn: [
        { name: "customerCode", label: "شماره مشتری", visibility: true },
        { name: "customerName", label: "مشتری", visibility: true },
      ],
      showRow: true,
      addRow: false,
      editRow: false,
      copyRow: false,
      render: false,
      itemForEdit: {},
      itemForCopy: {},
    };
  },

  mounted() {
    this.getPropsRows();
  },

  methods: {
    changeState(state) {
      if (state == 0) {
        this.showRow = true;
        this.addRow = false;
        this.editRow = false;
        this.copyRow = false;
      }
      if (state == 1) {
        this.showRow = false;
        this.addRow = true;
        this.editRow = false;
        this.copyRow = false;
      }
      if (state == 2) {
        this.showRow = false;
        this.addRow = false;
        this.editRow = true;
        this.copyRow = false;
      }
      if (state == 3) {
        this.showRow = false;
        this.addRow = false;
        this.editRow = false;
        this.copyRow = true;
      }
    },

    copy(item) {
      this.itemForCopy = item;
      this.changeState(3);
    },

    addRowResult(isSuccess) {
      if (isSuccess) {
        this.changeState(0);
        this.getPropsRows();
      }
    },
    editRowResult(isSuccess) {
      if (isSuccess) {
        this.changeState(0);
        this.getPropsRows();
      }
    },
    getPropsRows() {
      let DataaxiosDepUser = {
        Action: "PriceList/PriceListDetail",
        Method: "get",
        ArryfildValue: null,
      };

      this.$PostData(DataaxiosDepUser)
        .then((res) => {
          this.propsRows = res;
          this.render = false;
          this.$nextTick(() => {
            this.render = true;
          });
        })
        .catch((err) => {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "خطایی رخ داد",
            "error",
            2000
          );
          console.error(err);
        });
    },

    editRowResult(isSuccess) {
      if (isSuccess) {
        this.changeState(0);
        this.getPropsRows();
      }
    },

    edit(item) {
      this.itemForEdit = item;
      this.changeState(2);
    },

    print(item) {
      this.$router.push({
        name: "PriceListExportPrint",
        params: { item: item },
      });
    },

    remove(item) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mx-1",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "اطمینان دارید؟",
          text: "از حذف " + "؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "بله، حذف شود",
          cancelButtonText: "لغو",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosDepUser = {
              Action: "PriceList/DeletePriceListDetail/" + item.id,
              Method: "Delete",
              ArryfildValue: null,
            };
            this.$PostData(DataaxiosDepUser)
              .then((response) => {
                if (response.isSuccess) {
                  var record = this.propsRows.find((x) => x.id == item.id);
                  var index = this.propsRows.indexOf(record);
                  this.propsRows.splice(index, 1);
                  this.render = false;
                  this.$nextTick(() => {
                    this.render = true;
                  });
                  this.$toasted.success("حذف با موفقیت صورت گرفت", {
                    action: {
                      text: "بستن",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      },
                    },
                  });
                } else {
                  swalWithBootstrapButtons.fire(
                    "",
                    "حذف به دلیل رابطه با سایر جداول صورت نگرفت",
                    "info"
                  );
                }
              })
              .catch((error) => {
                console.error("CATCH", error);
                swalWithBootstrapButtons.fire(
                  "",
                  "عملیات با خطا مواجه شد",
                  "error"
                );
              });
          }
        });
    },
  },
};
</script>

<style scoped>

</style>
